module.exports = __webpack_public_path__ + "img/a11_4.31975c4f.jpg";